<template>
  <v-form
    class="py-8 bg-light-blue-main"
    @submit.prevent>
    <v-row class="pa-4">
      <v-col cols="9">
        <v-container class="bordered bg-white">
          <NormalInput
            :id="nodeId"
            :field="nameField"
            :icon="type" />
        </v-container>
      </v-col>
      <v-col
        class="text-center"
        cols="3">
        <CalcLevel
          field="level"
          :node-id="nodeId"
          :level="level" />
      </v-col>
    </v-row>

    <slot name="element-buttons">
      <ElementButtons
        :child-types="childElements"
        hide-submit
        :node-id="nodeId" />
    </slot>

    <v-container>
      <slot name="default" />
    </v-container>
  </v-form>
</template>

<script setup lang="ts">
import ElementButtons from "@/components/Elements/ElementButtons.vue";
import CalcLevel from "@/components/Elements/CalcLevel.vue";
import { computed } from "vue";
import NormalInput from "@/components/Elements/NormalInput.vue";

const props = withDefaults(
  defineProps<{
    nodeId: string;
    childElements?: string[];
    level?: number;
    manufacturingStep?: boolean;
    variant?: boolean;
  }>(),
  {
    childElements: () => [],
    level: 1,
    manufacturingStep: false,
    variant: false
  }
);

const id = computed(() => {
  if (props.manufacturingStep) {
    return props.nodeId.replace("part", "manufacturingStep");
  }

  if (props.variant) {
    return props.nodeId.replace("part", "variant");
  }

  return props.nodeId;
});

const nameField = computed(() => {
  if (props.manufacturingStep) {
    return "manufacturing_step_name";
  }

  if (props.variant) {
    return "";
  }

  return "name";
});

const type = computed(() => {
  return id.value.split("_")[1];
});
</script>
